(function($) {
  // Spotlight
  function initSpotlight() {
    const spotlightTabWrapper = $('.spotlight-tabWrapper');
    
    // Tabs
    if (spotlightTabWrapper.length) {
      const spotlightTabs = $('.spotlight-tab', spotlightTabWrapper);
      const spotlightPanels = $('.spotlight-panel', spotlightTabWrapper);

      spotlightTabs.on('click', function() {
        // Reset
        spotlightTabs.attr('aria-selected', 'false');
        spotlightTabs.attr('tabindex', '-1');
        spotlightPanels.attr('aria-hidden', 'true');

        // Activate
        $(this).attr('aria-selected', 'true');
        $(this).attr('tabindex', '0');
        const selectedPanel = $('#' + $(this).attr('aria-controls'));
        selectedPanel.attr('aria-hidden', 'false');
        $(this).get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });

      // Keyboard access
      spotlightTabs.on('keydown', function(event) {
        // arrow keys
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          const currentTabIndex = spotlightTabs.index(this);
          let nextTabIndex = currentTabIndex;
          if (event.key === 'ArrowLeft') {
            nextTabIndex = (currentTabIndex - 1 + spotlightTabs.length) % spotlightTabs.length;
          } else if (event.key === 'ArrowRight') {
            nextTabIndex = (currentTabIndex + 1) % spotlightTabs.length;
          }
          spotlightTabs.eq(nextTabIndex).focus().click();
        }
        // tab
        if (event.key === 'Tab') {
          event.preventDefault();
          const selectedPanel = $('#' + $(this).attr('aria-controls'));
          const focusableElements = $('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', selectedPanel);
          focusableElements.eq(0).focus();
        }
      });

      // Carousels
      const spotlightCarousels = $('.spotlight-carousel', spotlightTabWrapper);

      spotlightCarousels.each(function() {
        const prevButton = $('[data-control="prev"]', this);
        const nextButton = $('[data-control="next"]', this);
        const items = $('.spotlight-carousel-item', this);
        const itemCount = items.length;
        let currentIndex = 0;

        const updateCarousel = () => {
          items.attr('aria-hidden', function(index) {
            return index === currentIndex ? 'false' : 'true';
          });
        };

        prevButton.on('click', () => {
          currentIndex = (currentIndex - 1 + itemCount) % itemCount;
          updateCarousel();
        });

        nextButton.on('click', () => {
          currentIndex = (currentIndex + 1) % itemCount;
          updateCarousel();
        });

        updateCarousel();
      });
    }
  }

  initSpotlight();
})(jQuery);